import React, { useEffect, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { Container, Grid, Header, Button, Form } from "semantic-ui-react";
import ErrorMessage from "../../../app/common/form/ErrorMessage";
import TextInput from "../../../app/common/form/TextInput";
import { Link } from "react-router-dom";
import { combineValidators, composeValidators, hasLengthGreaterThan, isRequired, isNumeric } from "revalidate";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import history from "../../..";
import { FORM_ERROR } from "final-form";
import { loginVerification, setCurrentAuthentication } from "../../../app/store/actions/authActions";
import { sendVerification } from "../../../app/store/actions/recoverActions";
import * as appConstants from "../../../app/infrastructure/appConstants";
import { toast } from "react-toastify";

const mapState = (state) => ({
    authentication: state.auth.authentication,
});

const actions = {
    loginVerification,
    sendVerification,
    setCurrentAuthentication
};

const ValidationPage = ({
    loginVerification,
    authentication
}) => {

    const [sendVerificationLoading, setSendVerificationLoading] = useState(false);

    useEffect(() => {
        if (authentication === null) return history.push('/login');
    }, []);

    const validate = combineValidators({
        code: composeValidators(
            isRequired({ message: "El código es requerido" }),
            hasLengthGreaterThan(5)({ message: "Debe tener al menos 6 dígitos." }),
            isNumeric({ message: "El código solo admite números." })
        )(),
    });

    return (
        <Container className="containerFormLogin">
            <FinalForm
                onSubmit={(values) => loginVerification({
                    "idValidacion": authentication.data.idValidacion,
                    "idVerificacion": authentication.data.idVerificacion,
                    "codigoVerificacion": values.code,
                    "tipoDocumento": authentication.tipoDocumento,
                    "numeroDocumento": authentication.numeroDocumento
                }).catch((error) => ({ [FORM_ERROR]: error }))}
                validate={validate}
                render={({
                    handleSubmit,
                    submitting,
                    submitError,
                    invalid,
                    pristine,
                    dirtySinceLastSubmit,
                }) => (
                    <div style={{ paddingTop: '90px' }}>
                        <Form onSubmit={handleSubmit} autoComplete="off" error>

                            <Header as="h1" content="Verificación de seguridad" color="blue" textAlign="center" />

                            <p>Hemos enviado un código de verificación a tu correo electrónico registrado. Por favor, ingrésalo a continuación para continuar.</p>

                            <p style={{ fontSize: '0.8rem', fontStyle: "italic", fontFamily: "sans-serif" }}>Si no recibiste el correo, verifica tu bandeja de spam o intenta reenviarlo. <br />El código tiene una validez de 5 minutos.</p>

                            <Field name="code" component={TextInput} placeholder="Código" maxLength={6} />

                            {submitError && !dirtySinceLastSubmit && <ErrorMessage error={submitError} />}

                            <div style={{ marginBottom: '20px' }}>
                                <Button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setSendVerificationLoading(true);
                                        sendVerification({
                                            "idValidacion": authentication.data.idValidacion,
                                            "metodoVerificacion": appConstants.CODIGO_METODO_VERIFICACION_EMAIL
                                        }).then((response) => {
                                            const idVerificacion = response.data.idVerificacion;
                                            const tempAuthentication = { ...authentication };
                                            tempAuthentication.data.idVerificacion = idVerificacion;
                                            setCurrentAuthentication(tempAuthentication);
                                            toast.success("Se envió el núevo código al correo.")
                                        }).finally(() => {
                                            setSendVerificationLoading(false);
                                        });
                                    }}
                                    loading={sendVerificationLoading}
                                    fluid
                                    basic
                                    color="blue"
                                    size="mini"
                                    content="¿No recibiste el código? Haz clic aquí recibir un código nuevo."
                                />
                            </div>

                            <Grid divided="vertically">
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <Button
                                            fluid
                                            size="large"
                                            color="blue"
                                            content="Cancelar"
                                            as={Link}
                                            to="/"
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Button
                                            fluid
                                            disabled={(invalid && !dirtySinceLastSubmit) || pristine}
                                            size="large"
                                            loading={submitting}
                                            color="yellow"
                                            content="Validar"
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </div>
                )}
            />
        </Container>
    )
}

ValidationPage.propTypes = {
    loginVerification: PropTypes.func.isRequired,
    sendVerification: PropTypes.func.isRequired,
    setCurrentAuthentication: PropTypes.func.isRequired,
    authentication: PropTypes.object,
};

export default connect(mapState, actions)(ValidationPage);